var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCrownCardTrending = function SvgIconCrownCardTrending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#000",
    fillOpacity: 0.4,
    rx: 12.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEC90B",
    d: "M7.8 17.965c0 .158.126.287.287.287h8.829c.158 0 .287-.13.287-.287v-1.05H7.8zM19.558 8.76a.29.29 0 0 0-.345.01l-3.797 3.02-2.665-4.909c-.098-.187-.402-.184-.502 0L9.583 11.79 5.786 8.77a.285.285 0 0 0-.341-.01.29.29 0 0 0-.112.324l2.358 7.255h9.62l2.356-7.255a.29.29 0 0 0-.11-.325"
  })));
};
export default SvgIconCrownCardTrending;